var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"collection-total-results body-sm"},[_vm._v(_vm._s(_vm.currentTotal)+" "+_vm._s(_vm.results))])])}
var staticRenderFns = []

export { render, staticRenderFns }